import axios from "axios";
import { buildAttachmentPreviewUrl } from "./preview/attachmentUtils";
import { emailMessagePath } from "./emailApiPaths";

function escapeRegExp(s) {
  return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function normalizeCid(cid) {
  return String(cid || "")
    .trim()
    .replace(/^<|>$/g, "");
}

/** Sustituye src="cid:…" por URLs de preview del API (iframes/img en el navegador). */
export function replaceCidWithPreviewUrls(html, attachments = []) {
  if (!html || !/cid:/i.test(html)) return html;

  let out = html;
  for (const att of attachments) {
    const cid = normalizeCid(att.cid || att.contentId);
    if (!cid || !att.id) continue;
    const url = buildAttachmentPreviewUrl(att.id);
    const escaped = escapeRegExp(cid);
    out = out.replace(new RegExp(`cid:${escaped}`, "gi"), url);
    out = out.replace(
      new RegExp(`(src\\s*=\\s*["'])cid:${escaped}(["'])`, "gi"),
      `$1${url}$2`
    );
  }
  return out;
}

export async function resolveHtmlInlineImagesForDisplay(apiBase, gmailId, html) {
  const raw = String(html || "");
  if (!raw || !/cid:/i.test(raw)) return raw;

  try {
    const res = await axios.get(emailMessagePath(apiBase, gmailId, "attachments"), {
      timeout: 20_000,
    });
    const files = Array.isArray(res.data) ? res.data : [];
    return replaceCidWithPreviewUrls(raw, files);
  } catch (err) {
    console.warn("No se pudieron resolver imágenes inline:", err);
    return raw;
  }
}
